import {
  LitElement,
  html,
  nothing
} from 'lit';

import icons from './icons/_index.js';
import IconStyle from './style.js';
import { kebabToReadable } from '../../util/index.js';

export class LdsIcon extends LitElement {
  static get styles() {
    return IconStyle;
  }

  static properties = {
    decorative: { type: Boolean },
    description: { type: String },
    fill: { type: String },
    inline: { type: Boolean },
    label: { type: String },
    name: { type: String },
  };

  constructor() {
    super();
    this.decorative = false;
    this.description = undefined;
    this.fill = undefined;
    this.inline = false;
    this.label = undefined;
    this.name = '';
  }

  getIconName() {
    if (Object.hasOwn(icons, this.name)) return this.name;

    // eslint-disable-next-line no-console
    console.error(`Icon name "${this.name}" was not found in the LDS Enterprise icon library; check that the name is correctly spelled Pascal case LDS icon name variable`);
    return '_error';
  }

  ariaLabeledBy() {
    return [
      this.getLabel && `lds-icon-${this.getIconName()}-title`,
      this.description && `lds-icon-${this.getIconName()}-description`,
    ]
      .filter((item) => item)
      .join(' ');
  }

  getLabel() {
    if (this.label) return this.label;
    return kebabToReadable(this.getIconName());
  }

  descriptionHtml() {
    if (!this.description) return null;

    return html`
      <desc
        id="lds-icon-${this.getIconName()}-description"
      >
        ${this.description}
      </desc>
    `;
  }

  labelHtml() {
    return html`
      <title
        id="lds-icon-${this.getIconName()}-title"
      >
        ${ this.getLabel() }
      </title>
    `;
  }

  render() {
    return html`<svg
        class="icon icon-${this.getIconName()} ${this.inline ? 'inline' : ''}"
        style="${this.fill ? `fill: ${this.fill};` : nothing}"
        aria-hidden="${this.decorative || nothing}"
        role="img"
        focusable="false"
        aria-labelledby="${this.ariaLabeledBy() || nothing}"
      >${this.labelHtml()}${this.descriptionHtml()}${icons[this.getIconName()]}</svg>`;
  }
}

export function defineComponent() {
  if (!window.customElements.get('lds-icon')) window.customElements.define('lds-icon', LdsIcon);
}

export default { LdsIcon, defineComponent };
